import { render, staticRenderFns } from "./SearchSelect.vue?vue&type=template&id=510ea6fd&scoped=true"
import script from "./SearchSelect.vue?vue&type=script&lang=ts"
export * from "./SearchSelect.vue?vue&type=script&lang=ts"
import style0 from "./SearchSelect.vue?vue&type=style&index=0&id=510ea6fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ea6fd",
  null
  
)

export default component.exports